import { render } from "./Warehousingservices.vue?vue&type=template&id=3e28e49c&scoped=true"
import script from "./Warehousingservices.vue?vue&type=script&lang=js"
export * from "./Warehousingservices.vue?vue&type=script&lang=js"

import "./Warehousingservices.vue?vue&type=style&index=0&id=3e28e49c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e28e49c"]])

export default __exports__